// Tickets: anyone signed in sends one from Settings (or the user menu's Tickets): a problem, a request for
// a feature or for access, or a correction to data, with how urgent it is. Administrators (admin:tickets)
// see them all in Administration › Tickets and accept or deny each one, with a reply if they like; the
// person who sent it is told on the bell and by email, and sees the answer in Settings. An open ticket can
// be withdrawn by whoever sent it; a decision can be changed, or the ticket put back to open. A ticket can
// carry up to TICKET_MAX_FILES screenshots (pictures only), added by whoever sent it while it's open: kept in
// R2 under tickets/<ticket>/, one row each in `ticket_files`, seen by the sender and the administrators.
// Kept in D1 (`tickets`); the worker (routes/tickets.ts) and the web (Settings, pages/admin/Tickets.tsx) share
// this.
import { z } from 'zod';
export const TICKET_CATEGORIES = ['problem', 'feature', 'access', 'data', 'other'];
export const TICKET_CATEGORY_LABEL = {
    problem: 'Something isn’t working',
    feature: 'A new feature or change',
    access: 'Access or permissions',
    data: 'Wrong or missing data',
    other: 'Something else',
};
export const TICKET_PRIORITIES = ['low', 'normal', 'urgent'];
export const TICKET_PRIORITY_LABEL = { low: 'Low', normal: 'Normal', urgent: 'Urgent' };
export const TICKET_STATUSES = ['open', 'accepted', 'denied', 'withdrawn'];
export const TICKET_STATUS_LABEL = { open: 'Open', accepted: 'Accepted', denied: 'Denied', withdrawn: 'Withdrawn' };
/** a ticket holds up to this many screenshots */
export const TICKET_MAX_FILES = 5;
/** and each can be up to this big (a big photo is scaled down in the browser first) */
export const TICKET_MAX_FILE_BYTES = 10 * 1024 * 1024;
/** where a screenshot is served (`download` asks for it as a download rather than to open) */
export const ticketFileUrl = (id, download = false) => `/api/tickets/file?id=${encodeURIComponent(id)}${download ? '&dl=1' : ''}`;
/** a ticket's reference from its number */
export const ticketRef = (id) => `T-${id}`;
/** a new ticket */
export const TicketCreateSchema = z
    .object({
    category: z.enum(TICKET_CATEGORIES),
    priority: z.enum(TICKET_PRIORITIES).default('normal'),
    subject: z.string().trim().min(3, 'Say in a few words what it is about').max(120),
    details: z.string().trim().max(4000).default(''),
    page: z.string().trim().max(120).default(''),
})
    .strict();
/** an administrator's decision: accept or deny it (with a reply), or put it back to open */
export const TicketDecideSchema = z
    .object({
    id: z.number().int().positive(),
    decision: z.enum(['accepted', 'denied', 'open']),
    reply: z.string().trim().max(2000).optional(),
})
    .strict();
/** the sender takes back a ticket still open */
export const TicketWithdrawSchema = z.object({ id: z.number().int().positive() }).strict();
/** the sender takes a screenshot back off a ticket that's still open */
export const TicketFileDeleteSchema = z.object({ id: z.string().min(1).max(64) }).strict();
//# sourceMappingURL=ticket.js.map